// This is the Client-side UI Interface for the Identification screen, providing form validation.

const $ = App.common.jQuery

const LoginForm = require('common/models/form-identification')
const FormValidation = require('client/js/helpers/form-validation')

// Timeout after Submit in seconds
const SUBMIT_TIMEOUT = 20

class IdentificationUI {
   // Init is called when the page first loads.
   static init() {
      FormValidation.init('#login_form', LoginForm, (err, result) => {
         let form = $('#login_form')
         let formdata = form.serializeObject()
         // console.log('Login Validation', err, result, formdata)
         if (result) return; // Invalid!

         // Disable submit button for a bit to stop double-submits
         let subbtn = form.find('*[type="submit"]')
         subbtn.prop('disabled', true)
         subbtn.addClass('continuing')
         setTimeout(()=> {
            subbtn.prop('disabled', false)
            subbtn.removeClass('continuing')
         }, SUBMIT_TIMEOUT * 1000)

         form.trigger('submit')
      })
   }
}

module.exports = IdentificationUI
